document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.js-remove-bundled');
    if (!link) return;

    var bundleId = link.getAttribute('data-bundle-id');
    if (!bundleId) return;

    e.preventDefault();

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var keysToRemove = [];
        cart.items.forEach(function(item) {
          if (item.properties && item.properties._bundle_id === bundleId) {
            keysToRemove.push(item.key);
          }
        });

        var updates = {};
        keysToRemove.forEach(function(key) {
          updates[key] = 0;
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function() {
        window.location.reload();
      });
  });
});
